function playVideo(videoEl) {
  videoEl
    .play()
    .then(() => {
      // eslint-disable-next-line no-console
      console.log('Autoplay success!');
    })
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log('Autoplay error', error);
    });
}

function init() {
  const mobileVideo = document.querySelector('.js-mobile-video');
  const desktopVideo = document.querySelector('.js-desktop-video');

  if (mobileVideo) {
    playVideo(mobileVideo);
  }

  if (desktopVideo) {
    playVideo(desktopVideo);
  }
}

(() => {
  init();
})();
